import { render, staticRenderFns } from "./TableShopify.vue?vue&type=template&id=a5c77620&scoped=true"
import script from "./TableShopify.vue?vue&type=script&lang=js"
export * from "./TableShopify.vue?vue&type=script&lang=js"
import style0 from "./TableShopify.vue?vue&type=style&index=0&id=a5c77620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c77620",
  null
  
)

export default component.exports